export const faqData = [
    {
        id: 1,
        question: "What is the question?",
        answer: "What is the question?",
    },
    {
        id: 2,
        question: "What is the question?",
        answer: "What is the question?",
    },
    {
        id: 3,
        question: "What is the question?",
        answer: "What is the question?",
    },
    {
        id: 4,
        question: "What is the question?",
        answer: "What is the question?",
    },
    {
        id: 5,
        question: "What is the question?",
        answer: "What is the question?",
    },
    {
        id: 6,
        question: "What is the question?",
        answer: "What is the question?",
    },
    {
        id: 7,
        question: "What is the question?",
        answer: "What is the question?",
    },{
        id: 8,
        question: "What is the question?",
        answer: "What is the question?",
    },{
        id: 9,
        question: "What is the question?",
        answer: "What is the question?",
    },{
        id: 10,
        question: "What is the question?",
        answer: "What is the question?",
    },{
        id: 11,
        question: "What is the question?",
        answer: "What is the question?",
    },{
        id: 12,
        question: "What is the question?",
        answer: "What is the question?",
    },

]